<template>
  <el-rate
      :colors="['#FAD20C','#FAD20C','#FAD20C']"
      void-color="#D8DADD"
      disabled-void-color="#D8DADD"
      v-bind="$attrs"
      v-on="$listeners">
  </el-rate>
</template>

<script>
  export default {
    name: "gj-rate"
  }
</script>

<style scoped>

</style>
